import axios from "axios";
import { message } from "antd";
import { getQueryString } from "@/utils/tools";

const baseReq = axios.create({
  baseURL: `/shop/api/sites/${getQueryString('siteId')}/sms/`,
  timeout: 5000
});

const baseImgReq = axios.create({
  baseURL: "/pic",
  timeout: 5000
});

baseReq.interceptors.response.use(res => {
  if (res.data.code === 0) {
    return res.data.data;
  } else {
    message.error(res.data.msg);
    return Promise.reject(res.data.msg);
  }
});

/*
 *  遍历签名
 */
export const getSignatureList = (status = null, size, page = 0) => {
  status = status === "all" ? null : status;
  return baseReq({
    method: "get",
    url: "/list_signs",
    params: {
      status,
      size,
      page
    }
  });
};

/*
 *  修改签名
 */
export const updateSignature = (old_sign, sign) => {
  return baseReq({
    method: "put",
    url: "/update_sign",
    params: { old_sign: old_sign.signContent, sign }
  });
};
/*
 *  上传图片
 */
export const uploadImg = (site_id, apic) => {
  const formData = new FormData();
  formData.append("site_id", site_id);
  formData.append("apic", apic);
  return baseImgReq({
    method: "post",
    url: "/ajax-upload-pic-by-verify",
    data: formData
  });
};

/*
 *  添加签名
 */
export const addSignatures = (sign_content, industry_type, license) => {
  if (!(sign_content && industry_type && license)) {
    message.warn("签名信息不完整,请检查并重新填写");
    return;
  }
  const formData = new FormData();
  formData.append("sign_content", sign_content);
  formData.append("industry_type", industry_type);
  formData.append("license_url", license);
  return baseReq({
    method: "post",
    url: "/add_sign",
    data: formData
  }).then(
    res => {
      message.info("添加成功,请在签名管理页查看");
      window.setTimeout(() => {
        window.location.href = `/v5/message?siteId=${getQueryString('siteId')}`;
      }, 500);
    },
    err => {
      message.error("新增签名失败,请检查并重试");
    }
  );
};
